'use strict';
import angular from 'angular';
import './scripts/tieredLookups.ctrls';
import './scripts/tieredLookups.services';

import tieredLookupsHtmlUrl from './views/tieredLookups.html';
import tieredLookupContentsHtmlUrl from './views/tieredLookupContents.html';

angular.module('tieredLookups', [
    'tieredLookups.ctrls',
    'tieredLookups.services'
])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('tieredLookups', {
                parent: 'layout',
                url: '/admin/tieredLookups',
                templateUrl: tieredLookupsHtmlUrl,
                controller: 'TieredLookupController'
            })
            .state('tieredLookupContents', {
                parent: 'layout',
                url: '/admin/tieredLookupsContents/:tierTypeId',
                templateUrl: tieredLookupContentsHtmlUrl,
                controller: 'TieredLookupContentController'
            })
    }]);